export const FormRegistrationEmailTranslationsUk = {
  email: 'Електронна пошта',
  password: 'Пароль',
  registration: 'Зареєструватися',
  privacyPolicyText: 'Натисканням на Зареєструватися ви приймаєте',
  privacyPolicyLinkText: 'Політику конфіденційності',

  // errors
  'Required field': 'Обов`язкове поле',
  'Enter a valid email address': 'Введіть дійсну адресу електронної пошти',
  'Password must be at least 8 characters':
    'Пароль має бути не менше 8 символів',
  'Password must be less than 32 characters':
    'Пароль має бути менше 32 символів',
  'Password must contain at least 8 Latin characters, one uppercase letter, one digit':
    'Пароль повинен містити мінімум 8 латинських символів, одну велику літеру, одну цифру',

  // errors back-end
  'Email in use': 'Електронна пошта вже використовується.',
};
